module.exports = __webpack_public_path__ + "static/media/trimex_medallaoro.43d82f15.png";